module.exports = __webpack_public_path__ + "img/王春艳.6da3ef07.jpg";